import React from "react";
import { imgStyle, labelStyle } from "./eventStyles";

/**
 * File input plus optional preview for a single event image (app or web pop-up).
 * Reusable so both image slots share the same required/preview behavior without duplicating markup.
 */
const EventImageField = ({ label, previewSrc, onChange, required }) => (
    <>
        <label style={labelStyle}>{label}</label>
        <input
            type="file"
            accept="image/*"
            onChange={onChange}
            style={{ marginBottom: '20px' }}
            required={required && !previewSrc}
        />
        {previewSrc ? <img alt={label} src={previewSrc} style={imgStyle} /> : null}
    </>
);

export default EventImageField;
